import React from 'react';
import PropTypes from 'prop-types';
import DashboardLayout from '../shared/Dashboard';

const DoctorDashboard = ({ user, handleLogout }) => (
  <DashboardLayout user={{ ...user, role: 'doctor' }} handleLogout={handleLogout}>

    <p>
      Welcome,
      {user?.name}
      !
    </p>
  </DashboardLayout>
);

DoctorDashboard.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  handleLogout: PropTypes.func.isRequired,
};

export default DoctorDashboard;
